// extracted by mini-css-extract-plugin
module.exports = {"header":"Layer_header__1E9rb"};